import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './SPSCommerce.frontend.types'

@Injectable({ providedIn: 'root' })
export class SPSCommerce_create_order_with_validationService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { orders?: $frontendTypes.FootprintApiManager.DatexOrderInfo[] }): Promise<{ messages?: any[], results?: { request_id?: string, order_id?: string, reference_code?: string, project?: string, warehouse?: string, message?: string, order?: any, entities?: any, transaction_id?: string }[], reasons?: string[] }> 
  {
    let $url = `${environment.backendUrl}api/Create/Order`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

